import $http from '$http'
import {util} from 'utils';

export default {
    methods: {
        getList () {
            this.loading=true;//拼命加载中显示
            var Params = { Sid: this.sysSid, Session: this.sysSession, pageIndex: this.pageIndex, pageSize: this.pageSize };
            Params = Object.assign({}, Params, this.filterData);
            $http.get("api/Agent/GetAgentPoorList",Params).then(res=>{
                let { Data, Cnt } = res.data;
                util.doResult(this,res,()=>{
                    this.totalSize=Cnt;
                    this.loading = false;//拼命加载中显示
                    this.lists = Data;
                });
            });
        },
        req_AgentPoorReceive (data) {
            $http.post('api/Agent/Agent_PoorReceive', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '接收成功！',
                        type: 'success'
                    });
                    this.getList();
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMagentPoor/services.js